import { Textfield } from '@src/shared/fields/text-field';

export function StageAudienceSection() {
  return (
    <section className='rounded-xl border border-[#E8E7F0] bg-white p-4'>
      <p className='mb-4 text-sm font-semibold text-gray-500'>
        1. Audience Details
      </p>

      <Textfield
        label='Reminder name'
        name='name'
        placeholder='Enter Reminder Name'
      />
    </section>
  );
}
